export default __webpack_public_path__ + "static/media/icon-clock.2638f639.svg";